import { ApiKeyStatusEnum, IApiAccessKey } from "./ApiAccessOversightInterfaces";

/**
 * Derive the display status of a key with the SAME first-match-wins precedence the
 * OS-2549 auth middleware uses (contract §5.5): Revoked -> Expired -> Active. Keeping
 * this identical to the gate order means MBO display and API behaviour never disagree.
 */
export const deriveKeyStatus = (
    key: Pick<IApiAccessKey, "revoked_at" | "expires_at">,
    now: Date = new Date(),
): ApiKeyStatusEnum => {
    if (key.revoked_at) {
        return ApiKeyStatusEnum.Revoked;
    }
    // `<=` so a key at the exact expiry instant is Expired, matching the server aggregate's
    // active filter (`expires_at _gt now`) — the two surfaces must never disagree (contract §5.5).
    if (new Date(key.expires_at).getTime() <= now.getTime()) {
        return ApiKeyStatusEnum.Expired;
    }
    return ApiKeyStatusEnum.Active;
};
